export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.name = item != null ? item.name : ''
        this.domainName = item != null ? item.domainName : ''
        this.logo = item != null ? item.logo.base64 : ''
        this.primaRelatienummer = item != null ? item.primaRelatienummer : ''
        this.active = item != null ? item.active ? 'true' : 'false' : 'true'
    }
}